module.exports = __webpack_public_path__ + "static/img/Craig-Kelly.077d589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Craig-Kelly.jpg
// module id = Nro2
// module chunks = 1